module.exports = __webpack_public_path__ + "img/activity_2_vid_2_splash.dc2139a9.jpg";